import { parseAsSelection } from './parse-as-selection';
import { parseAsTimestamp } from './parse-as-timestamp';

/**
 * Parser map for logger stream URL search params.
 * Shared by useLoggerParams (hooks) and buildLoggerStreamUrl (programmatic URLs)
 * so serialization format stays consistent.
 */
export const loggerStreamSearchParsers = {
  cursor: parseAsTimestamp,
  from: parseAsTimestamp,
  to: parseAsTimestamp,
  selection: parseAsSelection,
} as const;
